<script setup lang="ts">
const props = defineProps({
  object: {
    type: Object as PropType<Sanity.Default.Schema.Accordion>,
    required: true,
  },
})

const accordionItems = ref(props.object?.accordionItems?.map((item, index) => {
  return {
    label: item.title,
    content: '',
    text: item.text,
    defaultOpen: index === 0,
  }
}))

const { urlFor } = useSanityImage()
</script>

<template>
  <div v-if="object" class="container-8xl pb-16">
    <div v-if="object.eyebrow" class="eyebrow">
      {{ object.eyebrow }}
    </div>
    <h3 v-if="object.heading" class="text-2xl lg:text-4xl text-gray-700 font-semibold mb-3">
      {{ object.heading }}
    </h3>
    <div v-if="object.body">
      <SanityContentWrapper
        :blocks="object.body"
      />
    </div>
    <div class="mx-auto flex max-w-2xl flex-col items-start justify-start gap-16 lg:mx-0 lg:max-w-none lg:flex-row">
      <div class="w-full lg:max-w-lg lg:flex-auto">
        <nuxt-img
          v-if="object.image"
          :src="urlFor(object.image).width(500).height(500).fit('crop').url() ?? ''"
          quality="85"
          :alt="object.image.alt ?? 'Careers image'"
          width="500"
          height="500"
          class="aspect-[1/1] w-full bg-gray-50 object-cover"
          loading="lazy"
          :placeholder="object.image.asset?.metadata?.lqip ?? ''"
        />
      </div>
      <div class="w-full lg:max-w-xl lg:flex-auto">
        <UAccordion :items="accordionItems" :ui="{ wrapper: 'flex flex-col w-full' }">
          <template #default="{ item, index, open }">
            <UButton color="gray" variant="ghost" class="pl-4 md:pl-0 border-t border-gray-200 first:border-0" :ui="{ rounded: 'rounded-none', padding: { sm: 'p-3' } }">
              <span class="inline text-sm text-primary-500">0{{ index + 1 }}</span>
              <span class="text-ellipsis overflow-hidden text-left text-base section-title py-4 mx-4">
                {{ item.label }}
              </span>
              <template #trailing>
                <UIcon
                  name="i-heroicons-chevron-right-20-solid"
                  class="w-5 h-5 ms-auto transform transition-transform duration-200 text-primary-500"
                  :class="[!open && 'rotate-90']"
                />
              </template>
            </UButton>
          </template>
          <template #item="{ item }">
            <div class="text-gray-700 text-sm pb-4 mb-0 pl-4 md:pl-0">
              <SanityContentWrapper :blocks="item.text" />
            </div>
          </template>
        </UAccordion>
      </div>
    </div>
  </div>
</template>
